export default __webpack_public_path__ + "static/media/tagme4.d6a26650.jpg";